export class DatadogEvents {
  static FAILED_TO_RETRIEVE_DATA = 'FAILED_TO_RETRIEVE_DATA';
  static DEALERTRACK_SSO_ERROR_PAGE = 'DEALERTRACK_SSO_ERROR_PAGE';

  static LOG_CATEGORIES: Record<string, string> = {
    [DatadogEvents.FAILED_TO_RETRIEVE_DATA]: 'Failed to retrieve data',
    [DatadogEvents.DEALERTRACK_SSO_ERROR_PAGE]: 'Dealertrack SSO error page displayed',
  };
}
